module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\"><g fill=\"#31AF64\" fill-rule=\"evenodd\"><path d=\"M12.5 7c0-3.038-2.462-5.5-5.5-5.5S1.5 3.962 1.5 7s2.462 5.5 5.5 5.5 5.5-2.462 5.5-5.5zM0 7c0-3.866 3.134-7 7-7s7 3.134 7 7-3.134 7-7 7-7-3.134-7-7z\"/><path d=\"M6.28 7.697L5.045 6.464c-.117-.117-.305-.117-.42-.002l-.614.614c-.11.113-.11.303.007.42l1.91 1.91c.19.19.51.197.703.004l.264-.265L9.997 6.04c.108-.107.107-.293-.01-.408l-.612-.614c-.114-.113-.298-.12-.41-.01L6.28 7.7z\"/></g></svg>\n"


//////////////////
// WEBPACK FOOTER
// ./cycle_analytics/svg/icon_build_status.svg
// module id = ./cycle_analytics/svg/icon_build_status.svg
// module chunks = cycle_analytics